import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemDms} from '../DM/FormChooseDm.jsx'
import Model from './ModelDv.mjs'

export const FormItemDvName = props => (
    <FormItemBizProp
        Model={Model}
        prop="dvName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemDvUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="dvUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseDv(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemDms />
            <FormItemDvUserCode />
            <FormItemDvName />
        </FormChooseDesign>
    )
}
